import React from "react";

import { FormLabel, TextField } from "@mui/material";

import Tooltip from "@mui/material/Tooltip";

import { Backspace, Check, Clear, Edit } from "@mui/icons-material";

//Styles
import { withStyles } from "tss-react/mui";
import GridItem from "../Grid/GridItem";
import Button from "../CustomButtons/Button";
import TimeTableStyle from "./TimeTableStyle";

import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";

class TimeSlot extends React.Component {
  state = {
    startTime: this.props.startTimeOrg,
    stopTime: this.props.stopTimeOrg,
    maxItems: this.props.maxItems,
    editing: this.props.editing,
  };

  handleInputChange = (type, value) => {
    const oldState = { ...this.state };
    oldState[type] = value;
    this.setState(oldState);
  };

  isValid = (type) => {
    const startTime = this.convertToMinuts(this.state.startTime);
    const stopTime = this.convertToMinuts(this.state.stopTime);

    switch (type) {
      case "startTime":
        return startTime < stopTime;
      case "stopTime":
        return stopTime > startTime;
    }

    return false;
  };

  canSave = () => {
    return this.isValid("startTime") && this.isValid("stopTime");
  };

  convertToMinuts = (input) => {
    const hoursMinuts = input.split(":");
    return parseInt(hoursMinuts[0] * 60 + hoursMinuts[1]);
  };

  toggleEditing = () => {
    this.setState({ editing: !this.state.editing });
  };

  getData = () => {
    const data = {
      startTime: this.state.startTime,
      stopTime: this.state.stopTime,
    };

    if (this.state.maxItems > 0) {
      data["maxItems"] = this.state.maxItems;
    }

    return data;
  };

  save = () => {
    if (this.props.isNewSlot) {
      this.props.handleTimeSettings(this.props.arrPlace, "ADD", this.getData());

      this.props.toggleEmptySlots();
    } else {
      this.props.handleTimeSettings(this.props.arrPlace, "UPDATE", this.getData());
      this.setState({
        editing: false,
      });
      this.props.forceRefresh();
    }
  };

  removeItem = () => {
    this.props.handleTimeSettings(this.props.arrPlace, "DELETE");
    this.props.forceRefresh();
  };

  reset = () => {
    if (this.props.isNewSlot) {
      this.props.toggleEmptySlots();
    } else {
      this.setState({
        startTime: this.props.startTimeOrg,
        stopTime: this.props.stopTimeOrg,
        maxItems: this.props.maxItems,
        editing: false,
      });
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <GridItem className={classes.timeSlot}>
        {!this.state.editing ? (
          <div>
            <div>
              <p style={{ display: "inline" }}>
                {this.state.startTime} {<TranslationWrapper tDefault={"tot"} tKey={"global.tot"} />}{" "}
                {this.state.stopTime}
              </p>
              <Tooltip
                classes={{ tooltip: classes.tooltip }}
                placement={"bottom"}
                title={<TranslationWrapper tDefault={"Verwijderen"} tKey={"global.button.verwijderen"} />}
              >
                <Button className={classes.actionButton} color={"danger"} onClick={this.removeItem} simple>
                  <Backspace className={classes.icon} />
                </Button>
              </Tooltip>
              <Tooltip
                classes={{ tooltip: classes.tooltip }}
                placement={"bottom"}
                title={<TranslationWrapper tDefault={"Edit"} tKey={"global.jamezzTable.edit"} />}
              >
                <Button className={classes.actionButton} color={"success"} onClick={this.toggleEditing} simple>
                  <Edit className={classes.icon} />
                </Button>
              </Tooltip>
            </div>
            {this.props.showMaxItems ? (
              this.state.maxItems > 0 ? (
                <div>
                  {this.state.maxItems}{" "}
                  <TranslationWrapper tDefault={"Items per blok"} tKey={"components.timeslots.maxItems"} />
                </div>
              ) : (
                <div>
                  <TranslationWrapper
                    tDefault={"Onbeperkt aantal items"}
                    tKey={"components.timeslots.maxItems.onbeperkt"}
                  />
                </div>
              )
            ) : null}
          </div>
        ) : (
          <div>
            <div>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                className={classes.textField}
                error={!this.isValid("startTime")}
                id={"time"}
                inputProps={{
                  step: 300, // 5 min
                }}
                onChange={(e) => this.handleInputChange("startTime", e.target.value)}
                type={"time"}
                value={this.state.startTime}
              />
              <FormLabel className={classes.labelHorizontal}>
                <TranslationWrapper tDefault={"tot"} tKey={"global.tot"} />
              </FormLabel>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                className={classes.textField}
                error={!this.isValid("stopTime")}
                id={"time"}
                inputProps={{
                  step: 300, // 5 min
                }}
                onChange={(e) => this.handleInputChange("stopTime", e.target.value)}
                type={"time"}
                value={this.state.stopTime}
              />
              <Tooltip
                classes={{ tooltip: classes.tooltip }}
                placement={"bottom"}
                title={<TranslationWrapper tDefault={"Annuleren"} tKey={"global.tooltip.annuleren"} />}
              >
                <Button className={classes.actionButton} color={"warning"} onClick={this.reset} simple>
                  <Clear className={classes.icon} />
                </Button>
              </Tooltip>
              <Tooltip
                classes={{ tooltip: classes.tooltip }}
                placement={"bottom"}
                title={<TranslationWrapper tDefault={"Opslaan"} tKey={"global.tooltip.opslaan"} />}
              >
                <Button
                  className={classes.actionButton}
                  color={"success"}
                  disabled={!this.canSave()}
                  onClick={this.save}
                  simple
                >
                  <Check className={classes.icon} />
                </Button>
              </Tooltip>
            </div>
            {this.props.showMaxItems ? (
              <div>
                <TextField
                  inputProps={{
                    min: 0,
                  }}
                  onChange={(e) => this.handleInputChange("maxItems", e.target.value)}
                  type={"number"}
                  value={this.state.maxItems}
                />
                <TranslationWrapper tDefault={"Items per blok"} tKey={"components.timeslots.maxItems"} />
              </div>
            ) : null}
          </div>
        )}
      </GridItem>
    );
  }
}

export default withStyles(TimeSlot, TimeTableStyle);
